import type { SafeAuthErrorCode } from "./auth-types.ts";
import { SafeAuthError } from "./auth-types.ts";

interface FirebaseAuthFailure {
  readonly code?: unknown;
}

export function safeFirebaseAuthErrorCode(error: unknown): SafeAuthErrorCode {
  const code = (error as FirebaseAuthFailure | null)?.code;
  if (typeof code !== "string") return "unexpected-error";

  switch (code) {
    case "auth/user-disabled":
      return "account-disabled";
    case "auth/admin-restricted-operation":
      return "account-not-provisioned";
    case "auth/network-request-failed":
      return "network-unavailable";
    case "auth/popup-closed-by-user":
    case "auth/cancelled-popup-request":
      return "popup-closed";
    case "auth/popup-blocked":
    case "auth/web-storage-unsupported":
    case "auth/operation-not-supported-in-this-environment":
      return "google-sign-in-unavailable";
    case "auth/invalid-verification-code":
    case "auth/code-expired":
    case "auth/invalid-multi-factor-session":
      return "invalid-mfa-code";
    case "auth/invalid-credential":
    case "auth/wrong-password":
    case "auth/user-not-found":
    case "auth/invalid-email":
      return "invalid-credentials";
    default:
      return "unexpected-error";
  }
}

export function toSafeFirebaseAuthError(error: unknown): SafeAuthError {
  return new SafeAuthError(safeFirebaseAuthErrorCode(error));
}
